import { queryOptions } from '@tanstack/react-query';

import type { AppShellData } from './get-app-shell-data.ts';
import { getAppShellData } from './get-app-shell-data.ts';

export const APP_SHELL_QUERY_KEY = ['app-shell-data'] as const;

export function getAppShellDataQueryOptions() {
	return queryOptions<AppShellData>({
		queryFn: () => getAppShellData(),
		queryKey: APP_SHELL_QUERY_KEY,
	});
}
